module.exports = __webpack_public_path__ + "static/img/op_logo.99e6563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top/op_logo.png
// module id = Eu88
// module chunks = 0